export function weeksToDate(startDate: string | undefined | null, weeks: number): Date | null {
  if (!startDate) return null;
  const base = new Date(startDate);
  if (Number.isNaN(base.getTime())) return null;
  if (!Number.isFinite(weeks)) return null;
  const result = new Date(base.getTime());
  result.setDate(result.getDate() + Math.round(weeks * 7));
  return result;
}

export function formatCompletionDate(date: Date | null): string {
  if (!date) return '';
  return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function weeksToDateLabel(startDate: string | undefined | null, weeks: number): string {
  return formatCompletionDate(weeksToDate(startDate, weeks));
}
